import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import FontAwesome from "react-fontawesome";
import Image1 from "../../../assets/images/featuresOverlay/3_5_0/DE_3-5-0_screen-0.png";
import Image2 from "../../../assets/images/featuresOverlay/3_5_0/DE_3-5-0_screen-1.png";
import Image3 from "../../../assets/images/featuresOverlay/3_5_0/DE_3-5-0_screen-2.png";
import Image4 from "../../../assets/images/featuresOverlay/3_5_0/DE_3-5-0_screen-3.png";
import Image5 from "../../../assets/images/featuresOverlay/3_5_0/DE_3-5-0_screen-4.png";
import Image6 from "../../../assets/images/featuresOverlay/3_5_0/DE_3-5-0_screen-5.png";
import Image7 from "../../../assets/images/featuresOverlay/3_6_0/DE_3-6-0_screen-1.png";
import Image1EN from "../../../assets/images/featuresOverlay/3_5_0/EN_3-5-0_screen-0.png";
import Image2EN from "../../../assets/images/featuresOverlay/3_5_0/EN_3-5-0_screen-1.png";
import Image3EN from "../../../assets/images/featuresOverlay/3_5_0/EN_3-5-0_screen-2.png";
import Image4EN from "../../../assets/images/featuresOverlay/3_5_0/EN_3-5-0_screen-3.png";
import Image5EN from "../../../assets/images/featuresOverlay/3_5_0/EN_3-5-0_screen-4.png";
import Image6EN from "../../../assets/images/featuresOverlay/3_5_0/EN_3-5-0_screen-5.png";
import Image7EN from "../../../assets/images/featuresOverlay/3_6_0/EN_3-6-0_screen-1.png";
import { Modal } from "../../UI";

class ReleaseOverlay extends Component {
  hideOverlay = () => {
    this.props.onHideOverlay();
  };

  render() {
    const { appLanguage, isVisible } = this.props;

    const arrowStyles = {
      position: "absolute",
      zIndex: 2,
      top: "calc(50% - 15px)",
      width: 30,
      height: 30,
      cursor: "pointer",
      border: "none",
      outline: "none"
    };

    const indicatorStyles = {
      background: "#fff",
      width: 8,
      height: 8,
      display: "inline-block",
      margin: "0 8px"
    };

    return (
      <Modal
        size="lg"
        onHideModal={this.hideOverlay}
        isOpen={isVisible}
        modalHeader={<div></div>}
        modalBodyStyle={{ align: "center" }}
        modalBody={
          <Carousel
            showArrows={true}
            showThumbs={false}
            showStatus={false}
            renderArrowNext={(onClickHandler, hasNext, label) =>
              hasNext && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  title={label}
                  style={{ ...arrowStyles, right: 15 }}
                >
                  <FontAwesome name="chevron-right"></FontAwesome>
                </button>
              )
            }
            renderArrowPrev={(onClickHandler, hasPrev, label) =>
              hasPrev && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  title={label}
                  style={{ ...arrowStyles, left: 15 }}
                >
                  <FontAwesome name="chevron-left"></FontAwesome>
                </button>
              )
            }
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              if (isSelected) {
                return (
                  <li
                    style={{ ...indicatorStyles, background: "#000" }}
                    aria-label={`Selected: ${label} ${index + 1}`}
                    title={`Selected: ${label} ${index + 1}`}
                  />
                );
              }
              return (
                <li
                  style={indicatorStyles}
                  onClick={onClickHandler}
                  onKeyDown={onClickHandler}
                  value={index}
                  key={index}
                  role="button"
                  tabIndex={0}
                  title={`${label} ${index + 1}`}
                  aria-label={`${label} ${index + 1}`}
                />
              );
            }}
          >
            <div>
              <img src={appLanguage === "en" ? Image7EN : Image7} />
            </div>
            <div>
              <img src={appLanguage === "en" ? Image1EN : Image1} />
            </div>
            <div>
              <img src={appLanguage === "en" ? Image2EN : Image2} />
            </div>
            <div>
              <img src={appLanguage === "en" ? Image3EN : Image3} />
            </div>
            <div>
              <img src={appLanguage === "en" ? Image4EN : Image4} />
            </div>
            <div>
              <img src={appLanguage === "en" ? Image5EN : Image5} />
            </div>
            <div>
              <img src={appLanguage === "en" ? Image6EN : Image6} />
            </div>
          </Carousel>
        }
        modalFooter={<></>}
      />
    );
  }
}

export default ReleaseOverlay;
